<template>
    <v-layout row wrap style="margin-top: 40px">
        <v-flex xs12 class="text-center">
            <h2>Bestattungsdienstleistungen</h2>
        </v-flex>

        <v-flex xs2>
            <v-switch v-bind:label="service.ceremonie ? 'Beerdigung' : 'Ohne Beerdigung'" v-model="service.ceremonie"></v-switch>
        </v-flex>
        <v-flex xs3>
            <v-combobox filled v-if="service.ceremonie" v-bind:items="localitesLieuxCulte" label="Ort" v-model="service.localiteCeremonie" @input="findLieuxCeremonie()"></v-combobox>
        </v-flex>
        <v-flex xs3>
            <v-combobox no-data-text="Wählen Sie einen Ort..." filled v-if="service.ceremonie" v-bind:items="lieuxCulte" return-object item-text="lieu" label="Kirche" type="text" v-model="service.lieuCeremonie" @input="setLieuVeilPres"></v-combobox>
        </v-flex>
        <v-flex xs2>
            <v-text-field filled v-if="service.ceremonie" label="Datum" type="date" v-model="service.dateCeremonie"></v-text-field>
        </v-flex>
        <v-flex xs2>
            <v-text-field filled v-if="service.ceremonie" label="Zeit" type="time" v-model="service.heureCeremonie"></v-text-field>
        </v-flex>
        
        <v-flex xs12 style="margin: -48px 0 -48px 0">
            <v-switch v-if="service.ceremonie" label="mit Urne" v-model="service.ceremonieUrne"></v-switch>
        </v-flex>
        
        <v-flex xs2>
            <v-switch v-if="service.ceremonie" label="Beerdigung im engsten Kreis" v-model="service.ceremonieIntim"></v-switch>
        </v-flex>
        <v-flex xs3>
            <v-select filled v-if="service.ceremonie" v-bind:items="typeCeremonie" label="Art der Beerdigung" v-model="service.typeCeremonie"></v-select>
        </v-flex>
        <v-flex xs3>
            <v-text-field filled type="text" label="Hinterlegung" v-model="service.reposCorps"></v-text-field>
        </v-flex>
        <v-flex xs4>
        </v-flex>
        <v-flex xs3>
            <v-radio-group v-model="service.veilPres" column @change="setLieuVeilPres">
                <v-radio label="Ohne" value="sans"></v-radio>
                <v-radio label="Anwesenheit" value="presence"></v-radio>
                <v-radio label="Abendgebet" value="veille"></v-radio>
            </v-radio-group>
        </v-flex>
        <v-flex xs3 offset-xs2>
            <v-text-field filled v-if="service.veilPres=='veille' | service.veilPres=='presence'" label="Kirche" type="text" v-model="service.lieuVeilPres"></v-text-field>
        </v-flex>
        <v-flex xs2>
            <v-text-field filled v-if="service.veilPres=='veille' | service.veilPres=='presence'" label="Datum" type="date" v-model="service.dateVeilPres"></v-text-field>
        </v-flex>
        <v-flex xs2>
            <v-text-field filled v-if="service.veilPres=='veille' | service.veilPres=='presence'" label="Zeit" type="time" v-model="service.heureVeilPres"></v-text-field>
            <v-text-field filled v-if="service.veilPres=='presence'" label="Endzeit" type="time" v-model="service.heureFinVeilPres"></v-text-field>
        </v-flex>


        <v-flex xs3>
            <v-radio-group v-model="service.incinh" column>
                <v-radio label="Einäscherung" value="incineration"></v-radio>
                <v-radio label="Erdbestattung" value="inhumation"></v-radio>
            </v-radio-group>
        </v-flex>
        <v-flex xs3 offset-xs2>
            <v-combobox filled :label="service.incinh == 'incineration' ? 'Krematorium' : 'Friedhof'" :items="service.incinh == 'incineration' ? listeCrematoires : listeCimetieres" type="text" v-model="service.cimCrem"></v-combobox>
        </v-flex>
        <v-flex xs2>
            <v-text-field filled  label="Datum" type="date" v-model="service.dateIncInh"></v-text-field>
        </v-flex>
        <v-flex xs2>
            <v-text-field filled label="Zeit" type="time" v-model="service.heureIncInh"></v-text-field>
        </v-flex>



        <v-flex xs3 v-if="service.incinh == 'incineration'">
            <v-switch label="Abgabe der Asche an Familie" v-model="service.cendresFamille"></v-switch>
        </v-flex>

        <v-flex v-if="!service.cendresFamille && service.incinh == 'incineration'" xs3 offset-xs2>
            <v-combobox filled :items="listeCimetieres" type="text" label="Friedhof für die Beerdigung von Asche" v-model="service.lieuInhCendres"></v-combobox>
        </v-flex>
        <v-flex v-if="service.incinh == 'incineration'" xs2>
            <v-text-field filled label="Datum" type="date" v-model="service.dateInhCendres"></v-text-field>
        </v-flex>
        <v-flex v-if="service.incinh == 'incineration'" xs2>
            <v-text-field filled label="Zeit" type="time" v-model="service.heureInhCendres"></v-text-field>
        </v-flex>

        <v-flex xs2 offset-xs5 v-if="!service.cendresFamille && service.incinh == 'incineration'">
            <v-radio-group v-model="choixLieuInh" column @change="choixLienInhCendresChange()">
                <v-radio label="Erinnerungsgarten" value="jardin du souvenir"></v-radio>
                <v-radio label="Reiseroute Linie" value="ligne cinéraire"></v-radio>
                <v-radio label="Grab von" value="tombe de"></v-radio>
            </v-radio-group>
        </v-flex>
        <v-flex xs2 offset-xs5 v-if="service.incinh == 'inhumation'">
            <v-radio-group v-model="choixLieuInh" column @change="choixLienInhCendresChange()">
                <v-radio label="Linie" value="ligne"></v-radio>
                <v-radio label="Neue Konzession" value="nouvelle concession"></v-radio>
                <v-radio label="Bestehende Konzession" value="concession existante"></v-radio>
            </v-radio-group>
        </v-flex>
        <v-flex xs5 v-if="!service.cendresFamille">
            <v-text-field filled type="text" v-model="service.lieuInh"></v-text-field>
        </v-flex>
        <v-flex xs12 class="text-xs-center">
          <v-btn large color="primary" :loading="saveLoad" :disabled="saveLoad" @click.native="save()">Speichern</v-btn>
        </v-flex>

    <v-btn fab fixed color="warning" :loading="saveLoad" :disabled="saveLoad" @click.native="save()"><v-icon>mdi-content-save</v-icon></v-btn>
    </v-layout>
</template>
<script>
    import {ajax_post} from '../../public/global.js'
    export default {
      data(){
        return{
          service: {
              ceremonie: false,
              ceremonieIntim: false,
              ceremonieUrne: false,
              typeCeremonie: '',
              localiteCeremonie: '',
              lieuCeremonie: '',
              dateCeremonie: '',
              heureCeremonie: '',
              reposCorps: '',
              lieuVeil: '',
              lieuPres: '',
              lieuVeilPres: '',
              dateVeilPres: '',
              heureVeilPres: '',
              heureFinVeilPres: '',
              veilPres: '',
              incinh: 'incineration',
              cimCrem: '',
              dateIncInh: '',
              heureIncInh: '',
              lieuInh: '',
              lieuInhCendres: '',
              dateInhCendres: '',
              heureInhCendres: '',
              cendresFamille: false
          },
          lieuCeremonie: '',
          idLieuCerem: '',
          localitesLieuxCulte: [],
          lieuxCulte: [],
          lieuxCulteFull: {},
          listeCrematoires: [],
          listeCimetieres: [],
          choixLieuInh: '',
          ceremonie: true,
          incineration: true,
          saveLoad: false
        }
      },
      computed: {
          typeCeremonie : function () {
              if(this.service.incinh!='incineration'){
                  return ["messe d'enterrement", 'dernier Adieu', 'liturgie de la parole', 'culte']
              }else{
                  return ['office de sépulture', 'dernier Adieu', 'liturgie de la parole', 'culte']
              }
          }
      },
      methods: {

        fetchData (){
          //services du défunts
          ajax_post(`/PHP/ajax/returnSaveService.php`,`token=${this.$token()}&choice=return&id=${this.$route.params.id}`).then((response) =>{
            let rep = JSON.parse(response)
            if(!rep.error){
              if(rep.data){
                this.idLieuCerem = rep.data.id_lieu_ceremonie
                this.service.ceremonie = (rep.data.ceremonie == 1 ? true : false)
                this.service.ceremonieIntim = (rep.data.ceremonie_intim == 1 ? true : false)
                this.service.ceremonieUrne = (rep.data.ceremonie_urne == 1 ? true : false)
                this.service.typeCeremonie = rep.data.type_ceremonie
                this.service.localiteCeremonie = rep.data.ceremonie_loc
                this.service.lieuCeremonie = rep.data.ceremonie_lieu
                this.lieuCeremonie = rep.data.ceremonie_lieu
                this.service.reposCorps = rep.data.repos_corps
                this.service.dateCeremonie = rep.data.ceremonie_date
                this.service.heureCeremonie = rep.data.ceremonie_heure
                this.service.lieuVeilPres = rep.data.veillance_lieu
                this.service.dateVeilPres = rep.data.veillance_date
                this.service.heureVeilPres = rep.data.veillance_heure
                this.service.heureFinVeilPres = rep.data.veillance_heure_fin
                this.service.veilPres = rep.data.veillance
                this.service.incinh = rep.data.inc_inh
                this.service.cimCrem = rep.data.cim_crem
                this.service.dateIncInh = rep.data.inc_inh_date
                this.service.heureIncInh = rep.data.inc_inh_heure
                this.service.lieuInh = rep.data.inhumation_lieu
                this.service.cendresFamille = (rep.data.cendres_famille == 1 ? true : false)
                this.service.lieuInhCendres = rep.data.lieu_inh_cendres
                this.service.dateInhCendres = rep.data.date_inh_cendres
                this.service.heureInhCendres = rep.data.heure_inh_cendres
              }
            }else{
              this.$root.$emit('myinfo', {title: "Serenity", msg: rep.msg, color: "error"})
            }
          })
          
          //liste des localités, lieux de culte, crématoires et cimetières
          ajax_post(`/PHP/ajax/returnLieuxCulteCremCim.php`,`token=${this.$token()}`).then((response) =>{
            let rep = JSON.parse(response)
            if(!rep.error){
              this.lieuxCulteFull = rep.lieuxCulte
              
              //on récupére uniquement les localité des lieux de culte en faisant un array.map ensuite array.filter pour supprimer les doublons
              this.localitesLieuxCulte = rep.lieuxCulte.map(elem => elem.localite).filter((value, index, self) => self.indexOf(value) === index)
              
              //récupération des crématoires
              this.listeCrematoires = rep.crematoires.map(elem => elem.nom)

              //récupération des cimetières
              this.listeCimetieres = rep.cimetieres.map(elem => elem.nom)
            
            }else{
              this.$root.$emit('myinfo', {title: "Serenity", msg: rep.msg, color: "error"})
            }
          })
        },

        saveNext(){
          this.saveLoad = true
          ajax_post(`/PHP/ajax/returnSaveService.php`, `token=${this.$token()}&idLieuCerem=${this.idLieuCerem}&choice=save&id=${this.$route.params.id}&ceremonie=${(this.service.ceremonie ? 1 :0)}&ceremonieIntim=${(this.service.ceremonieIntim ? 1 :0)}&ceremonieUrne=${(this.service.ceremonieUrne ? 1 :0)}&localiteCeremonie=${this.service.localiteCeremonie}&typeCeremonie=${this.service.typeCeremonie}&lieuCeremonie=${this.lieuCeremonie}&reposCorps=${this.service.reposCorps}&dateCeremonie=${this.service.dateCeremonie}&heureCeremonie=${this.service.heureCeremonie}&veilPres=${this.service.veilPres}&lieuVeilPres=${this.service.lieuVeilPres}&dateVeilPres=${this.service.dateVeilPres}&heureVeilPres=${this.service.heureVeilPres}&heureFinVeilPres=${this.service.heureFinVeilPres}&incinh=${this.service.incinh}&cimCrem=${this.service.cimCrem}&dateIncInh=${this.service.dateIncInh}&heureIncInh=${this.service.heureIncInh}&lieuInh=${this.service.lieuInh}&cendresFamille=${this.service.cendresFamille ? 1 : 0}&lieuInhCendres=${this.service.lieuInhCendres}&dateInhCendres=${this.service.dateInhCendres}&heureInhCendres=${this.service.heureInhCendres}`).then((response) =>{
            let rep = JSON.parse(response)
            if(!rep.error){
              this.saveLoad = false
              this.$root.$emit('myinfo', {title: "Serenity", msg: "Erfolgreich gespeichert !", color: ""})
            }else{
              this.saveLoad = false
              this.$root.$emit('myinfo', {title: "Serenity", msg: rep.msg, color: "error"})
            }
          })
        },

        findLieuxCeremonie (){
            let self = []
            let locToSearch = this.service.localiteCeremonie
            this.lieuxCulteFull.forEach(function(element) {
                if(element.localite == locToSearch){
                    self.push({lieu: element.lieu, id: element.id})
                }
            })
            this.lieuxCulte = self
        },

        setLieuVeilPres (){
            console.log(this.service.lieuCeremonie)


            this.service.lieuVeil = this.service.lieuCeremonie.lieu
            this.idLieuCerem = this.service.lieuCeremonie.id
            this.lieuCeremonie = (this.service.lieuCeremonie.lieu == undefined ? this.service.lieuCeremonie : this.service.lieuCeremonie.lieu)

            let selfLoc = this.service.localiteCeremonie
            let selfLieu = this.service.lieuCeremonie.lieu
            let self = ''
            this.lieuxCulteFull.forEach(function(element) {
                if(element.localite == selfLoc && element.lieu == selfLieu){
                    self = element.lieu_presence
                }
            })
            if(self != ''){
                this.service.lieuPres = self
            }
            if(this.service.lieuPres != ''){
                this.service.reposCorps = this.service.lieuPres
            }
            if(this.service.veilPres == 'presence'){
                this.service.lieuVeilPres = this.service.lieuPres
            }else if(this.service.veilPres == 'veille'){
                this.service.lieuVeilPres = this.service.lieuVeil
            }
        },

        choixLienInhCendresChange () {
            this.service.lieuInh = this.choixLieuInh
        },
        save(){
          setTimeout(() => {
            this.saveNext()
          }, 0)
        }

      },
      created () {
        this.fetchData()
      }
    }
</script>